import { useState, useHead } from "#imports";

type JsonLDObject = { [key: string]: JsonLDValue };
type JsonLDValue = string | number | JsonLDObject | JsonLDValue[];

export function useFAQJsonLD(faqs: { faqTitle: string; faqText: string }[]) {
  const allFAQs = useState<{ faqTitle: string; faqText: string }[]>(
    "allFaqsJsonLD",
    () => []
  );

  if (useRoute().path.includes("/faq")) {
    allFAQs.value = [...allFAQs.value, ...faqs];
  } else {
    allFAQs.value = [];
  }
  onMounted(() => {
    useHead(() => {
      const JsonLd = {
        "@context": "http://schema.org/",
        "@type": "FAQPage",
        mainEntity: allFAQs.value.map((faq) => ({
          "@type": "Question",
          name: faq.faqTitle,
          acceptedAnswer: {
            "@type": "Answer",
            text: faq.faqText,
          },
        })),
      };

      return {
        script:
          allFAQs.value.length > 0
            ? [
                {
                  type: "application/ld+json",
                  children: JSON.stringify(JsonLd),
                },
              ]
            : [],
      };
    });
  });
}
